<div class="mt-wrapper mt-wrapper--bg mt-grid" xmlns="http://www.w3.org/1999/html">
  <div class="row">
    <div class="col is10 off1">

      <section class="row mt-section mt-section--header">
        <div class="col is12">
          <h2 class="mt-h2">Bulk Import Fonts</h2>
        </div>
      </section>

      <section v-if="!hasPosted && !showBulkImportStatus" class="mt-section mt-section--bottom-large">
        <fou-group>
          <p class="mt-h3">Import New</p>
          <p class="mt-serif mt-serif--size4"></p>
        </fou-group>
        <bulk-metadata-uploader :id="$vId(this, `bulk-metadata-uploader`)" />
      </section>
      <section v-else-if="!showBulkImportStatus" class="mt-section mt-section--bottom-large">
        <div class="row">
          <div class="col is3">
            <p class="mt-serif--bold">Filename</p>
          </div>
          <div class="col is9">
            <p class="mt-serif">{{getFilename}}</p>
          </div>
        </div>

        <div class="row">
          <div class="col is3">
            <p class="mt-serif--bold">Import Status</p>
          </div>
          <div class="col is9">
            <p class="mt-serif">{{getResult.success?"Accepted for further processing":"Failed"}}</p>
          </div>
        </div>
        <div class="row" v-if="getResult.success">
          <div class="col is3">
            <p class="mt-serif--bold">TempImportVersion:</p>
          </div>
          <div class="col is9">
            <p class="mt-serif">{{getResult.tempImportVersion}}</p>
          </div>
        </div>
        <div class="row" v-else>
          <div class="col is3">
            <p class="mt-serif--bold">Error Message:</p>
          </div>
          <div class="col is9">
            <p class="mt-serif">{{getResult.error}}</p>
          </div>
        </div>
        <div class="row" v-if="getResult.warning">
          <div class="col is3">
            <p class="mt-serif--bold">Warning:</p>
          </div>
          <div class="col is9">
            <p class="mt-serif">{{getResult.warning}} found. Those values will be ignored by PIM</p>
          </div>
        </div>
      </section>

      <section v-if="(hasPosted)">
        <div class="row">
          <div class="col off8">
            <button type="button" class="mt-button" @click="reset()">Bulk Import Again</button>
          </div>
        </div>
      </section>

      <section class="mt-section">
        <BulkImportStatus :id="$vId(this, `bulk-import-status`)" />
      </section>
    </div>
  </div>
</div>
